import {
  DrawerFooter,
  DrawerFooterProps,
  makeStyles,
} from "@fluentui/react-components";


interface DrawerFooterCustomProps {
  rcName?: string;
  theme?: string;
}

const useStyles = makeStyles({
  footer: {
    borderTop: "1px solid rgb(234, 234, 234)",
    height: "64px",
    display: "flex",
  },
  footerDark: {
    borderTop: "1px solid rgb(0, 0, 0)",
    height: "64px",
    display: "flex",
  },
});

const DrawerFooterCustom = (
  props: DrawerFooterCustomProps & DrawerFooterProps
) => {
  const styles = useStyles();

  return (
    <DrawerFooter
      {...props}
      className={props.theme === "dark" ? styles.footerDark : styles.footer}
    />
  );
};

export default DrawerFooterCustom;
